import React, { useContext, useState } from 'react'
import { Grid, Typography, Box, Chip, Alert, Autocomplete, Checkbox, TextField, CircularProgress, Tooltip, IconButton, Button, Popover } from '@mui/material'
import { Error, Warning, WhatsApp } from '@mui/icons-material'
import { WhatsappDataContext } from '../WhatsappMessageContent'
import { Controller, useFormContext } from 'react-hook-form'

const TemplateSelection = () => {
    const {loading,templates, selectedTemplate, templateVariables,handleTemplateChange} = useContext(WhatsappDataContext)
    const { control,setValue} = useFormContext();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

  return (
    <>
        <Grid item xs={12} sm={7}>
            <Typography gutterBottom sx={{ 
                fontWeight: 600, 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                mb: 2,
                fontSize:'0.75rem'
            }}>
                <WhatsApp color="primary" />
                Configure WhatsApp Template
            </Typography>

            {/* Template Selection */}
            <Controller
                name='templateName'
                control={control}
                rules={{
                    required: 'Select a WhatsApp template',
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Autocomplete
                        size="small"
                        disableCloseOnSelect
                        options={templates}
                        value={ templates.find(t => t.name === value) || null }
                        loading={loading}
                        onChange={(event, newValue) => {
                            // let nValue = handleTemplateChange(event, newValue);
                            // setValue('languageCode', newValue ? newValue.language : '');
                            onChange(newValue ? newValue.name : '');
                            handleTemplateChange();
                        }}
                        getOptionLabel={(option) => {
                            return option.name || '';
                        }}
                        isOptionEqualToValue={(option, val) => option.name === val.name}
                        renderOption={(props, option, { selected }) => {
                            return (
                                <li {...props}>
                                    {/* <Checkbox checked={selected} size="small" sx={{ mr: 1 }} /> */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Box>
                                            <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
                                                {option.name}
                                            </Typography>
                                            <Typography sx={{ fontSize: '0.7rem', color: 'text.secondary' }}>
                                                <Chip 
                                                    label={option.language}
                                                    size="small" 
                                                    color="primary"
                                                    sx={{ height: 15, fontSize: '0.65rem' }}
                                                />  
                                                <Chip 
                                                    label={option.status } 
                                                    size="small" 
                                                    color={option.status === 'APPROVED' ? 'success' : option.status === 'PENDING' ? 'warning' : 'error'}
                                                    sx={{ height: 15, fontSize: '0.65rem',ml:1 }}
                                                />
                                            </Typography>
                                        </Box>
                                        {/* {option.status === 'APPROVED' && (
                                            <Chip 
                                                label="Approved" 
                                                size="small" 
                                                color="success"
                                                sx={{ height: 20, fontSize: '0.65rem' }}
                                            />
                                        )} */}
                                    </Box>
                                </li>
                            );
                        }}
                        noOptionsText={<span style={{ fontSize: '0.75rem' }}>No Template found</span>}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                placeholder="Select template"
                                InputProps={{
                                    ...params.InputProps,
                                    style: { fontSize: '0.75rem', color: '#000' },
                                    endAdornment: (
                                        <>
                                            {loading && <CircularProgress size={16} />}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                )}
            />
        </Grid>
        <Grid item xs={12} sm={5}>
            {selectedTemplate && (
                <>                                            
                    {/* Template Info */}
                    {/* us alert icon .. on hover show template info    */}
                    {/* <IconButton>
                        <Error color="primary" fontSize="small" />
                    </IconButton> */}
                    <Button size='small' sx={{ fontSize: '0.6rem', textTransform: 'capitalize'}} color='info' aria-describedby={id} variant="contained" onClick={(handleClick)}>
                        Show template info
                    </Button>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                         anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <Alert severity="info" sx={{ fontSize: '0.75rem' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                                Template: {selectedTemplate.name}
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>
                                Category: {selectedTemplate.category} | Language: {selectedTemplate.language}
                            </Typography>
                            {templateVariables.length > 0 && (
                                <Typography variant="body2" sx={{ fontSize: '0.7rem', mt: 0.5 }}>
                                    This template requires {templateVariables.length} parameter(s)
                                </Typography>
                            )}
                        </Alert>
                    </Popover>
                    
                </>
            )}
        </Grid>
    </>
  )
}

export default TemplateSelection
